import { makeRequest } from 'utils/requestLogger';

const createProfile = (id) => makeRequest('post', `/api/profiles/${id}/url`);

export default {
  createProfile,
};



// WEBPACK FOOTER //
// ./src/app/services/profile/profileServices.js